import MenuLink, { SubMenuLink } from "blocks/models/menu-link.interface";
import { OPEN_MEGA_DROPDOWN_MENU } from "layout/redux/overlay.actions";

let megaDropdownTimer: NodeJS.Timeout;

export default (event: any, item: MenuLink[] | undefined, subMenu: SubMenuLink[] | undefined, dispatch: any, overlay?: any) => {
    if (megaDropdownTimer) {
        clearTimeout(megaDropdownTimer);
    }

    if (overlay.currentOverlay === "MEGA_DROPDOWN_MENU") {
        megaDropdownTimer = setTimeout(() => {
            if (item && item.length > 0) {
                dispatch({
                    type: OPEN_MEGA_DROPDOWN_MENU,
                    menu: item,
                    subMenu: subMenu
                });
            }
            else {
                dispatch({
                    type: OPEN_MEGA_DROPDOWN_MENU,
                    menu: undefined,
                    subMenu: undefined
                });
            }
        }, 200);
    }
};